import React, { useState } from 'react';
import Img from 'img';
import Icon from 'icon';
import Button from 'button';
import { navigate, Link } from 'gatsby';
import Swiper from 'react-id-swiper';
import Headline from 'headline';
import Miscellaneous from 'shared/hero-miscellaneous';
import { formatDate } from 'utils/helpers';
import CategoryPill from 'shared/category-pill';
import 'swiper/dist/css/swiper.css';
import s from './hero-slider.module.scss';
import { useHeroImage } from '../../../hooks/useHeroImage';

export default function HeroSlider({ slides, ...props }) {
  const [swiper, updateSwiper] = useState(null);

  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  const params = {
    preloadImages: false,
    autoplay: {
      delay: 5000
    }
  };
  const { heroImage } = useHeroImage({ slides });

  return (
    <section className={s.root}>
      <div className={s.prev} onClick={goPrev}>
        <Icon icon="slider-prev" />
      </div>
      <div className={s.next} onClick={goNext}>
        <Icon icon="slider-next" />
      </div>
      <Swiper getSwiper={updateSwiper} {...params}>
        {slides.map(({ layout, image, title, category, editor, date, instagram_username, href, paragraph, button }, i) => {
          return layout === 'influencer_article' ? (
            <div className={s.wrapper} key={image.title}>
              <div className={s.overlay} onClick={() => navigate(href)} />
              <div className={s.imgWrapper}>
                <Img
                  className={s.img}
                  src={heroImage[i]}
                  alt={heroImage[i]?.title}
                />
              </div>
              <div className={`container ${s.content}`}>
                <div className={s.pillWrapper}>
                  <CategoryPill category={category?.name} />
                </div>
                <Link to={href} className={s.link}>
                  <Headline className={s.title} center h1 white html={title} />
                </Link>
                <Miscellaneous />
              </div>
            </div>
          ) : (
            <div className={s.wrapper} key={image.title}>
              <div className={s.overlay} />
              <div className={s.imgWrapper}>
                <Img
                  className={s.img}
                  src={heroImage[i]}
                  alt={heroImage[i]?.title}
                />
              </div>
              <div className={`container ${s.content}`}>
                {title && (
                  <Headline className={s.title} center h1 white html={title} />
                )}
                {paragraph && (
                  <p
                    className={s.text}
                    dangerouslySetInnerHTML={{ __html: paragraph }}
                  />
                )}
                <Miscellaneous />
                {button.text && (
                  <div className={s.buttonWrapper}>
                    <Button className={s.button} native href={button.href || '#'}>
                      {button.text}
                    </Button>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </Swiper>
    </section>
  );
}
